// extracted by mini-css-extract-plugin
var _1 = "ReactPageOfficeError__main--O0Kgc";
var _2 = "ReactPageOfficeError__message--V2Ksj CoreGeneral__roboto--UlmjE";
export { _1 as "main", _2 as "message" }
